/* Auto-generated file created by dtovbeinJC 03/12/2018 at 20:38:26hs */

import * as React from "react";
import * as ReactDOM from "react-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as PropTypes from "prop-types";
import { trimClassNames } from "../../utils/_helpers";
import { getNavigatorClass } from "../../utils/utils";
import styles from "./styles.css";
import shareIcon from "../../media/images/icons/shareIcon.png";

export const XButton = (props) => (
  <svg
    width="31px"
    height="31px"
    viewBox="-6.291 -4.79 31 31"
    enable-background="new -6.291 -4.79 31 31"
  >
    <g>
      <circle opacity="0.85" fill="#FFFFFF" cx="9.209" cy="10.71" r="15.5" />
      <g>
        <line
          fill="none"
          stroke="#F17E20"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="0.499"
          y1="2"
          x2="17.919"
          y2="19.42"
        />
        <line
          fill="none"
          stroke="#F17E20"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="17.919"
          y1="2"
          x2="0.499"
          y2="19.42"
        />
      </g>
    </g>
  </svg>
);

class Portal extends React.Component {
  static propTypes = {
    onRemoveContent: PropTypes.func.isRequired,
    marginTop: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      __name: "Portal",
      rerender: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.createPortal();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.wrapper.style = `height: 0; opacity: 0;`;
    const timerToClose = setInterval(() => {
      this.props.onRemoveContent();
      clearInterval(timerToClose);
      this.removeFromBody();
    }, 200);
  }

  removeFromBody() {
    if (this.portal) {
      document.body.removeChild(this.portal);
      ReactDOM.unmountComponentAtNode(this.portal);
    }
  }

  onCloseHandler = () => {
    this.wrapper.style = `height: 0; opacity: 0;`;
    const timerToClose = setInterval(() => {
      clearInterval(timerToClose);
      try {
        if (this.portal) this.props.onRemoveContent();
      } catch (e) {}
    }, 200);
  };

  createPortal() {
    this.portal = document.createElement("div");
    this.portal.style = `margin-top: 0; 
    height: 100%`;
    this.portal.className = trimClassNames([
      "portal",
      styles.portal,
      getNavigatorClass(),
    ]);
    this.wrapper = document.createElement("div");
    this.wrapper.className = styles.wrapper;

    let xCloseWrapper = document.createElement("div");
    xCloseWrapper.className = styles.btnClose;
    const xmlns = "http://www.w3.org/2000/svg";
    let xClose = document.createElementNS(xmlns, "svg");
    xClose.onclick = this.onCloseHandler;
    xClose.class = styles.btnClose;
    xClose.setAttributeNS(null, "width", "31px");
    xClose.setAttributeNS(null, "height", "31px");
    xClose.setAttributeNS(null, "viewBox", "-6.291 -4.79 31 31");
    xClose.setAttributeNS(null, "enableBackground", "new -6.291 -4.79 31 31");

    let shareImg = document.createElement("img");
    shareImg.src = shareIcon;
    shareImg.style.width = "24px";

    let shareLink = document.createElement("a");
    shareLink.href = `http://facebook.com/sharer/sharer.php?u=${document.URL}`;
    shareLink.target = "_blank";
    //shareLink.appendChild(shareImg);

    let g1 = document.createElementNS(xmlns, "g");
    let circle = document.createElementNS(xmlns, "circle");
    circle.setAttributeNS(null, "opacity", "1");
    circle.setAttributeNS(null, "fill", "#F17E20");
    circle.setAttributeNS(null, "cx", "9.209");
    circle.setAttributeNS(null, "cy", "10.71");
    circle.setAttributeNS(null, "r", "15.5");

    let g2 = document.createElementNS(xmlns, "g");
    let line1 = document.createElementNS(xmlns, "line");
    line1.setAttributeNS(null, "fill", "none");
    line1.setAttributeNS(null, "stroke", "#FFF");
    line1.setAttributeNS(null, "strokeWidth", "3");
    line1.setAttributeNS(null, "strokeLinecap", "round");
    line1.setAttributeNS(null, "strokeLinejoin", "round");
    line1.setAttributeNS(null, "strokeMiterlimit", "10");
    line1.setAttributeNS(null, "x1", "0.499");
    line1.setAttributeNS(null, "y1", "2");
    line1.setAttributeNS(null, "x2", "17.919");
    line1.setAttributeNS(null, "y2", "19.42");
    let line2 = document.createElementNS(xmlns, "line");
    line2.setAttributeNS(null, "fill", "none");
    line2.setAttributeNS(null, "stroke", "#FFF");
    line2.setAttributeNS(null, "strokeWidth", "3");
    line2.setAttributeNS(null, "strokeLinecap", "round");
    line2.setAttributeNS(null, "strokeLinejoin", "round");
    line2.setAttributeNS(null, "strokeMiterlimit", "10");
    line2.setAttributeNS(null, "x1", "17.919");
    line2.setAttributeNS(null, "y1", "2");
    line2.setAttributeNS(null, "x2", "0.499");
    line2.setAttributeNS(null, "y2", "19.42");
    g2.appendChild(line1);
    g2.appendChild(line2);
    xClose.appendChild(g1);
    g1.appendChild(circle);
    g1.appendChild(g2);
    xCloseWrapper.appendChild(xClose);

    this.wrapper.appendChild(shareLink);
    this.wrapper.appendChild(xCloseWrapper);
    this.portal.appendChild(this.wrapper);

    document.body.appendChild(this.portal);

    const timerToAnimate = setInterval(() => {
      this.wrapper.style = `height: 100%; opacity: 1;`;
      clearInterval(timerToAnimate);
    }, 100);
  }

  render() {
    const { children } = this.props;
    return <>{this.wrapper && ReactDOM.createPortal(children, this.wrapper)}</>;
  }
}

export default withRouter(Portal);
